
 function quickShopModalFunction() {
  let btns = []
  const closeBtns = document.querySelectorAll('.quickshop .close__btn')
  const modals = document.querySelectorAll('.quickshop.modal')

  btns = document.querySelectorAll('.quick__shop-btn')

  btns.forEach(btn => {
      btn.addEventListener("click", (e) => {
          const prodId = e.target.dataset.id
          const modal = document.querySelector(`.modal.quickshop[data-prodid="${prodId}"]`)
          const widget = modal.querySelector('.rc-container-wrapper')
  //         if (!widget) {
  //           const config = {
  //             productId: parseInt(prodId),
  //             injectionParent: '.subscription__widget', // The node that will have the widget injected in
  //             injectionMethod: 'prepend', // How will the widget be injected
  //           };
  //           window.ReChargeWidget.createWidget(config)
  //         }

            const overlay = document.createElement('div')
             overlay.classList.add('overlay')

          overlay.addEventListener("click", () => {
  //              const scrollY = document.body.style.top;
  //              document.body.style.position = '';
  //              document.body.style.top = '';
  //              window.scrollTo(0, parseInt(scrollY || '0') * -1);
              document.documentElement.style.overflowY = "unset"
              document.querySelector(`.modal.quickshop[data-prodid="${prodId}"]`).classList.add('hidden')
              document.querySelectorAll('.overlay').forEach((overlay) => overlay.remove());
          })
          document.body.appendChild(overlay)
          document.documentElement.style.overflowY = "hidden"
  //           document.body.style.position = 'fixed';
  //           document.body.style.top = `-${window.scrollY}px`;
          modal.classList.remove('hidden');

          modal.querySelectorAll('input[type="radio"][checked]').forEach((radio) => {
            radio.nextElementSibling.click();
          });
      })
  })
  closeBtns.forEach(btn => {
    btn.addEventListener("click", (e) => {
        e.target.closest('.quickshop').classList.add('hidden')
        document.querySelector('.overlay').remove()
        //window.history.pushState({}, null, '/') // removed as leads to bugs on collections pages.
        document.documentElement.style.overflowY = "unset"
//         const scrollY = document.body.style.top;
//         document.body.style.position = '';
//         document.body.style.top = '';
//         window.scrollTo(0, parseInt(scrollY || '0') * -1);
    })
  })

  modals.forEach(modal => {
    const submit = modal.querySelector('.product-form__buttons button');

      submit.addEventListener('click', (e) => {
        var error = document.querySelector('.quickshop:not(.hidden) .product-form__error-message-wrapper')
        var errorMessage = document.querySelector('.quickshop:not(.hidden) .product-form__error-message')
        const prod = modal.querySelector('.product__title').dataset.handle.toLowerCase().split(" ").join('-')
        const checkedOption = modal.querySelector('.quickshop.modal .product-form__input input:checked');
        const cartNotification = document.querySelector('cart-notification');

        jQuery.getJSON(`/products/${prod}.js`, function(product) {
          const prodVariants = product.variants

          jQuery.getJSON('/cart.js', function(cart) {
          var quantity = modal.querySelector('.quantity__input').value
          quantity = parseInt(quantity)
          var old_qty =  cart.item_count;
          var totals = quantity + old_qty
          console.log(totals)
          let variantId = ''
          let availability = false;
          prodVariants.forEach(variant => {
            if(checkedOption){
              if (variant.title === checkedOption.value) {
                variantId = variant.id
                availability = variant.available;
              }
            }else{
              variantId = product.variants[0].id
              availability = product.variants[0].available;
            }
          })
          if(availability){
            error.classList.add('hidden');
          if (document.querySelector('.rc_widget__option--active .rc_widget__option__input')){
            var item = document.querySelector('.rc_widget__option--active .rc_widget__option__input').id
          }else{
            var item =  'single';
          }

          if(item.indexOf('subsave')>= 0){
             var mySubString = item.substring(
                 item.indexOf(":") + 1,
                 item.lastIndexOf(";")
             );
             console.log(mySubString);
             var item_final = parseInt(mySubString);
             sellingPlan = product.selling_plan_groups[0].selling_plans[0].id;
             fetch('/cart/add.js', {
              method: 'POST',
              headers: {
                'Content-Type': 'application/json'
              },
              body: JSON.stringify({ items: [ { id: variantId, quantity: quantity, selling_plan: sellingPlan } ]})
            })
              .then(response => {
                // window.history.pushState({}, null, '/')
                e.target.closest('.quickshop').classList.add('hidden')
                document.documentElement.style.overflowY = "unset"
                document.querySelector('.overlay').remove()
                // Dropdown cart
                  console.log(cartNotification);
                  cartNotification.productJustAddedToCartByQuickAdd();
                // var notification = document.getElementById('cart-notification');
                // var cartItem = document.querySelector(".cart_items");
                // var cartNote = document.querySelector(".cart_note");
                // var cartProducts = document.querySelector(".cart_items_products");
                // cartNote.classList.remove('hidden');
                // cartItem.classList.add('hidden');
                // cartProducts.classList.add('hidden');
                // notification.classList.add('animate', 'active');
                // notification.addEventListener('transitionend', () => {
                //   notification.focus();
                //   trapFocus(notification);
                // }, { once: true });
                return response.json();
              })
              .then(response => {
                // if (old_qty <= 0){
                //   document.getElementById('cart-icon-bubble').innerHTML += '<div class="cart-count-bubble"><span aria-hidden="true" class="cart_qty_value">'+ totals  +'</span></div>';
                // }else{
                //   document.getElementsByClassName('cart_qty_value')[0].innerText = totals;
                // }

              })
              .catch((error) => {
                console.error('Error:', error);
                e.preventDefault();
              })


          }else{


            fetch('/cart/add.js', {
              method: 'POST',
              headers: {
                'Content-Type': 'application/json'
              },
              body: JSON.stringify({ items: [ { id: variantId, quantity: quantity } ]})
            })
              .then(response => {
                // window.history.pushState({}, null, '/')
                e.target.closest('.quickshop').classList.add('hidden')
                document.documentElement.style.overflowY = "unset"
                document.querySelector('.overlay').remove()
                // Dropdown cart
                  console.log(cartNotification);
                  cartNotification.productJustAddedToCartByQuickAdd();
                // var notification = document.getElementById('cart-notification');
                // var cartItem = document.querySelector(".cart_items");
                // var cartNote = document.querySelector(".cart_note");
                // var cartProducts = document.querySelector(".cart_items_products");
                // cartNote.classList.remove('hidden');
                // cartItem.classList.add('hidden');
                // cartProducts.classList.add('hidden');
                // notification.classList.add('animate', 'active');
                // notification.addEventListener('transitionend', () => {
                //   notification.focus();
                //   trapFocus(notification);
                // }, { once: true });
                return response.json();
              })
              .then(response => {
                if (old_qty <= 0){
                  document.getElementById('cart-icon-bubble').innerHTML += '<div class="cart-count-bubble"><span aria-hidden="true" class="cart_qty_value">'+ totals  +'</span></div>';
                }else{
                  document.getElementsByClassName('cart_qty_value')[0].innerText = totals;
                }

              })
              .catch((error) => {
                console.error('Error:', error);
                e.preventDefault();
              })
          }



        }else{
          console.log('item is not available')
          error.classList.remove('hidden');
          errorMessage.innerText = 'The product is sold out';
        }


  		});
      });
  	});
  });

}

document.addEventListener("DOMContentLoaded", () => {
  quickShopModalFunction();

  // Slider
  $jq('.js-quickshop-slider').each((index, slider) => {
    $jq(slider).slick({
      slidesToShow: 1,
      slidesToScroll: 1,
      infinite: false,
      fade: true,
      cssEase: 'linear',
      asNavFor: '.js-quickshop-thumbs',
      dots: false,
      arrows: true,
      responsive: [
        {
          breakpoint: 767,
          settings: "unslick"
        }
      ]
    });

    $jq(slider).next().slick({
      slidesToShow: 3,
      slidesToScroll: 1,
      infinite: false,
      asNavFor: '.js-quickshop-slider',
      dots: false,
      focusOnSelect: true
    });
  });
});
